export const IMPERIAL_ACTIONS = {
  SET_WIDTH_FRACTION: "set_init_width_fractions",
  SET_HEIGHT_FRACTION: "set_init_height_fractions",
  SET_DEPTH_FRACTION: "set_init_depth_fractions",
  SET_WIDTH_INTEGER: "set_init_width_integer",
  SET_HEIGHT_INTEGER: "set_init_height_integer",
  SET_DEPTH_INTEGER: "set_init_depth_integer",
  SET_WIDTH_CM: "set_init_width_cm",
  SET_DEPTH_CM: "set_init_depth_cm",
  SET_HEIGHT_CM: "set_init_height_cm",
};

// action handlers

const setWidthFraction = (fraction, state) => {
  return { ...state, init_width_fraction: fraction };
};

const setDepthFraction = (fraction, state) => {
  return { ...state, init_depth_fraction: fraction };
};

const setHeightFraction = (fraction, state) => {
  return { ...state, init_height_fraction: fraction };
};

const setWidthInteger = (value, state) => {
  return { ...state, init_width_integer: Math.round(value) };
};

const setDepthInteger = (value, state) => {
  return { ...state, init_depth_integer: Math.round(value) };
};

const setHeightInteger = (value, state) => {
  return { ...state, init_height_integer: Math.round(value) };
};

const setWidthInCm = (value, state) => {
  return {
    ...state,
    init_widthCm: value,
  };
};

const setDepthInCm = (value, state) => {
  return {
    ...state,
    init_depthCm: value,
  };
};

const setHeightInCm = (value, state) => {
  return {
    ...state,
    init_heightCm: value,
  };
};

export const imperialReducer = (state, action) => {
  switch (action.type) {
    case IMPERIAL_ACTIONS.SET_WIDTH_FRACTION:
      return setWidthFraction(action.fraction, state);
    case IMPERIAL_ACTIONS.SET_DEPTH_FRACTION:
      return setDepthFraction(action.fraction, state);
    case IMPERIAL_ACTIONS.SET_HEIGHT_FRACTION:
      return setHeightFraction(action.fraction, state);
    case IMPERIAL_ACTIONS.SET_WIDTH_INTEGER:
      return setWidthInteger(action.value, state);
    case IMPERIAL_ACTIONS.SET_DEPTH_INTEGER:
      return setDepthInteger(action.value, state);
    case IMPERIAL_ACTIONS.SET_HEIGHT_INTEGER:
      return setHeightInteger(action.value, state);
    case IMPERIAL_ACTIONS.SET_WIDTH_CM:
      return setWidthInCm(action.value, state);
    case IMPERIAL_ACTIONS.SET_DEPTH_CM:
      return setDepthInCm(action.value, state);
    case IMPERIAL_ACTIONS.SET_HEIGHT_CM:
      return setHeightInCm(action.value, state);
    default:
      return state;
  }
};
